import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();
  const numberTransform = (value: any) => (isNaN(value) ? undefined : value);

  const schema = yup.object().shape({
    id: yup.string().nullable().optional(),
    name: yup
      .string()
      .nullable()
      .test({
        name: 'test-empty-string',
        test(value, ctx) {
          if (value?.startsWith(' ')) {
            return ctx.createError({ message: t(`errorMessages.startSpace`) });
          }
          return true;
        },
      })
      .required(t(`errorMessages.required`))
      .max(64, t(`errorMessages.max`, { count: 64 })),
    information: yup
      .string()
      .nullable()
      .optional()
      .max(100, t(`errorMessages.max`, { count: 100 })),
    foodlocker: yup.boolean().required(t('errorMessages.required')),
    address: yup.object().shape({
      address: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: t(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(t('errorMessages.required')),
      city: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: t(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(t('errorMessages.required')),
      state: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: t(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(t('errorMessages.required')),
      zip: yup.string().nullable().required(t('errorMessages.required')),
      country: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: t(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(t('errorMessages.required')),
      coordinates: yup.object().shape({
        latitude: yup
          .number()
          .transform(numberTransform)
          .required(t('errorMessages.required'))
          .typeError(t('errorMessages.required')),
        longitude: yup
          .number()
          .transform(numberTransform)
          .required(t('errorMessages.required'))
          .typeError(t('errorMessages.required')),
      }),
    }),
  });

  return {
    schema,
  };
};
